import React from 'react';
interface HeroSectionProps {
  handlePurchase: () => void;
}
export function HeroSection({
  handlePurchase
}: HeroSectionProps) {
  return <header className="px-4 sm:px-[5%] py-12 sm:py-20 flex justify-center items-center min-h-[auto] sm:min-h-[70vh] relative overflow-hidden [contain:content]" role="banner" data-id="element-90">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-[50px] items-center w-full max-w-[1200px] relative z-10" data-id="element-91">
        {/* Mockup Visual */}
        <div className="relative flex flex-col items-center order-2 lg:order-1" data-id="element-92">
          <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(212,175,55,0.18)_0%,transparent_70%)] scale-150 z-0 top-[-10%]" aria-hidden="true" data-id="element-93" />

          {/* Mobile CTA above image */}
          <button onClick={handlePurchase} className="lg:hidden mb-8 bg-gold text-dark border-none py-4 px-6 text-base font-black rounded cursor-pointer transition-all duration-300 shadow-[0_15px_35px_rgba(212,175,55,0.3)] w-full max-w-[320px] active:scale-95 relative z-10" data-id="element-94">
            DOWNLOAD $6.39
          </button>
          <p className="lg:hidden text-[10px] text-gold font-bold mb-6 tracking-[2px] relative z-10" aria-hidden="true" data-id="element-95">
            ⚡ DIGITAL ACCESS • ONE-TIME PAYMENT
          </p>

          {/* CSS animation instead of framer-motion - removes ~40kb from critical path */}
          <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=450" srcSet="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=280 280w, https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=350 350w, https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=450 450w" sizes="(max-width: 640px) 280px, (max-width: 1024px) 350px, 450px" alt="888 Master Manual" width={450} height={580} className="relative z-10 w-full max-w-[280px] sm:max-w-[350px] lg:max-w-[450px] rounded-xl shadow-[0_40px_80px_rgba(0,0,0,0.9)] aspect-[3/4] animate-float" loading="eager" decoding="async" fetchPriority="high" data-id="element-96" />
        </div>

        {/* Texto de Ventas Hero - CSS fade-in instead of framer-motion */}
        <div className="text-center lg:text-left order-1 lg:order-2 animate-fadeInUp" data-id="element-97">
          <span className="inline-block bg-gold/10 text-gold px-4 py-1.5 rounded-full text-[10px] sm:text-xs font-extrabold tracking-wider mb-4 sm:mb-6" data-id="element-98">
            IMMEDIATE ACCESS OFFER
          </span>

          <h1 className="font-serif text-[32px] sm:text-[40px] lg:text-[56px] leading-[1.1] font-black mb-4 sm:mb-6" data-id="element-99">
            NEURO-QUANTUM <br data-id="element-100" />
            <span className="text-gold" data-id="element-101">PROGRAMMING</span>
          </h1>

          <p className="text-base sm:text-lg opacity-90 leading-[1.6] mb-8 sm:mb-10 max-w-xl mx-auto lg:mx-0" data-id="element-102">
            Tune your nervous system to the frequency of abundance and eliminate
            scarcity blocks in 15 minutes.
          </p>

          <button onClick={handlePurchase} className="hidden lg:inline-block bg-gold text-dark border-none py-5 px-8 text-lg font-black rounded cursor-pointer transition-all duration-300 shadow-[0_15px_35px_rgba(212,175,55,0.3)] w-full max-w-[400px] hover:scale-[1.03] hover:bg-[#f1c40f]" data-id="element-103">
            <span data-id="element-104">DOWNLOAD $6.39</span>
          </button>

          <p className="hidden lg:block text-xs text-gold font-bold mt-5 tracking-[2px]" aria-hidden="true" data-id="element-105">
            ⚡ DIGITAL ACCESS • ONE-TIME PAYMENT
          </p>

          <div className="hidden lg:flex flex-col gap-2.5 mt-6 max-w-[400px]" data-id="element-106">
            <div className="flex items-center gap-2.5 text-white/75 text-xs" data-id="element-107">
              <span className="text-gold" data-id="element-108">🔒</span>
              <span data-id="element-109">100% secure payment with PayPal and card</span>
            </div>
            <div className="flex items-center gap-2.5 text-white/75 text-xs" data-id="element-110">
              <span className="text-gold" data-id="element-111">⚡</span>
              <span data-id="element-112">Immediate access after your purchase</span>
            </div>
            <div className="flex items-center gap-2.5 text-white/75 text-xs" data-id="element-113">
              <span className="text-gold" data-id="element-114">✅</span>
              <span data-id="element-115">30-day money-back guarantee, no questions asked</span>
            </div>
          </div>
        </div>
      </div>
    </header>;
}